import request from "@/utils/request";
import {
  getInvestigateConfig,
  getInvestigateAndroid,
  getInvestigateEditAndroid,
  getInvestigateDetectionInfo,
  getDeviceLibListAndroid,
  editDevicesAndroid,
} from "@/api/androidApi";
import store from "@/store";

//列表配置
export function investigateConfig(data) {
  if (store.state.app.isAndroid) {
    return getInvestigateConfig(data);
  }
  return request({
    url: "/api/v1/investigateConfig",
    method: "get",
    params: {
      ...data,
    },
  });
}

//现场调查信息
export function investigate(data) {
  if (store.state.app.isAndroid) {
    return getInvestigateAndroid(data);
  }
  return request({
    url: "/api/v1/investigate",
    method: "get",
    params: {
      ...data,
    },
  });
}

// 现场调查信息编辑
export function investigateEdit(data) {
  if (store.state.app.isAndroid) {
    return getInvestigateEditAndroid(data);
  }
  return request({
    url: "/api/v1/investigateEdit",
    method: "post",
    data,
  });
}

//现场调查信息
export function investigateDetectionInfo(data) {
  if (store.state.app.isAndroid) {
    return getInvestigateDetectionInfo(data);
  }
  return request({
    url: "/api/v1/investigateDetectionInfo",
    method: "get",
    params: {
      ...data,
    },
  });
}

export function getDeviceLibList(data) {
  if (store.state.app.isAndroid) {
    return getDeviceLibListAndroid(data);
  }
  return request({
    url: `${process.env.VUE_APP_BASE_URL}/api/v1/oa/DeviceLib/list`,
    method: "get",
    params: {
      ...data,
    },
  });
}

export function editDevices(data) {
  if (store.state.app.isAndroid) {
    return editDevicesAndroid(data);
  }
  return request({
    url: `/api/v1/editDevices`,
    method: "post",
    data,
  });
}
